import cryptoStorage from 'localstorage-slim';

/** Encrypted local permissions — sidenav Billing + Settings → Billing gates. */
export interface Permissions {
  canSeeOtherShipment: boolean;
  canManageBilling?: boolean;
}

/**
 * Persist post-login session fields used by the app shell.
 * Must stay identical for login, set-password, verify-account, and SA impersonation
 * so Billing / load-visibility permissions are never missing after first login.
 */
export function persistAuthSession(payload: { data?: any } | any): void {
  const data = payload?.data ?? payload;
  const user = data?.user || {};

  localStorage.setItem('token', data?.accessToken);
  localStorage.setItem('companyId', user?.companyId);
  localStorage.setItem('role', user?.role);
  localStorage.setItem('email', user?.email);
  localStorage.setItem('name', `${user?.firstName || ''} ${user?.lastName || ''}`.trim());
  localStorage.setItem('phone', user?.phone);
  localStorage.setItem('userName', user?.userName);
  localStorage.setItem('profilePicture', user?.picture);
  localStorage.setItem('isBookable', JSON.stringify(user?.isBookable));
  localStorage.setItem('_id', user?._id);
  // Demo outbound UX (Save & Post) — also refreshed from CompanySessionService after getCompany.
  localStorage.setItem('demoMode', String(Boolean(data?.demoMode)));

  cryptoStorage.set<Permissions>(
    'permissions',
    {
      canSeeOtherShipment: user?.canSeeOtherShipment,
      // Primary account owner always has billing (D1) — same rule as login.
      canManageBilling: Boolean(user?.canManageBilling || user?.primaryUser),
    },
    { encrypt: true },
  );
}
